import { Node, nodeInputRule } from "@tiptap/core"

export const IMAGE_NODE = "image"
export const IMAGE_TITLE_NODE = "imageTitle"

/**
 * Matches an image to a ![image](src "title") on input.
 */
const inputRegex = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/

export const ImageNode = Node.create({
  name: IMAGE_NODE,
  group: "block",
  inline: false,
  draggable: true,

  addOptions() {
    return { HTMLAttributes: {} }
  },

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: element => element.querySelector("img")?.getAttribute("src"),
      },
      alt: {
        default: null,
        parseHTML: element => element.querySelector("img")?.getAttribute("alt"),
      },
      title: {
        default: null,
        parseHTML: element =>
          element.querySelector("img")?.getAttribute("title"),
      },
    }
  },

  parseHTML() {
    return [{ tag: `figure[data-type="${IMAGE_NODE}"]` }]
  },

  renderHTML({ HTMLAttributes }) {
    const { title, alt, src } = HTMLAttributes
    const imgAttrs = { alt, src, title }
    const figureAttrs = { "data-type": IMAGE_NODE }

    if (!title) return ["figure", figureAttrs, ["img", imgAttrs]]

    return [
      "figure",
      figureAttrs,
      ["img", imgAttrs],
      ["figcaption", { "data-subtype": IMAGE_TITLE_NODE }, title],
    ]
  },

  addInputRules() {
    return [
      nodeInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: match => {
          const [, , alt, src, title] = match
          return { src, alt, title }
        },
      }),
    ]
  },
})
